var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClockIcon = function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    fillRule: "evenodd",
    d: "M6.198 5.864A20.02 20.02 0 0 1 29.38 2.15 20 20 0 1 1 8.885 36.382l-2.63 3.3a.833.833 0 0 1-1.445-.265L1.407 28.788a.833.833 0 0 1 .865-1.083l11.12.947A.832.832 0 0 1 13.973 30l-3.008 3.767A16.705 16.705 0 1 0 3.667 20a1.667 1.667 0 1 1-3.334 0A20.02 20.02 0 0 1 6.198 5.864m12.957 1.29A1.667 1.667 0 0 1 22 8.335v10h10a1.666 1.666 0 1 1 0 3.333H20.333A1.667 1.667 0 0 1 18.667 20V8.333c0-.442.175-.866.488-1.178",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333 0h40v40h-40z"
  })))));
};
export default SvgClockIcon;